import F from 'offline/filter/constants'
// Port of api/fuel/app/classes/filter/package/games/game/package/group.php
export default {
	run: function(pkg, local, global) {
		var count = Object.keys((local.ratings && local.ratings.users) || {}).length
		pkg.group = {
			rating_count: count,
			rating_avg: count ? Math.round((local.ratings.average || 0) * 10) / 10 : '-',
			rating_band: count ? Math.floor(Math.round((local.ratings.average || 0) * 10) / 10) : '-'
		}
		return pkg
	}
}
